import { z } from 'zod'
import Model from '../Model'
import { CustomFieldValue } from './CustomFieldValue'

export default class JobItem extends Model {
  static readonly tableName: string = 'jobItems'
  static readonly apiEndPoint: string = 'api/job_items'
  static readonly sortKey: string = 'created_at'
  static readonly sortDirection = 'desc'
  static readonly bypassPendingRequests:
    | 'all'
    | ('delete' | 'saveMany' | 'create' | 'update')[] = []
  static readonly pusherChannelPrefix = 'job_items'

  job_id: string | number = ''
  item_id: string | number | null = ''
  description: string = ''
  details: string = ''
  estimated_qty: number = 0
  actual_qty: number = 0
  custom_field_values: CustomFieldValue[] = []
  created_id?: string | number = ''
  updated_id?: string | number = ''
  changed?: boolean

  // .refine() yields ZodEffects — base Model typing expects ZodObject; safeParse still works.
  static ZodValidator = z
    .object({
      details: z.string().max(20000).nullable(),
      job_id: z.coerce
        .string({
          required_error: 'The job field is required.',
        })
        .min(1, 'The job field is required.'),
      item_id: z.preprocess(
        (val) =>
          val === null || val === undefined || val === '' ? '' : String(val),
        z.string(),
      ),
      description: z.preprocess(
        (val) =>
          val === null || val === undefined || val === '' ? '' : String(val),
        z.string().max(255),
      ),
      estimated_qty: z.coerce.number().default(0),
      actual_qty: z.coerce.number().default(0),
      custom_field_values: z.array(CustomFieldValue.ZodValidator),
    })
    .refine(
      (data) =>
        !!(data.item_id && String(data.item_id).trim()) ||
        !!(data.description && String(data.description).trim()),
      {
        message: 'Either an item or a description is required.',
        path: ['description'],
      },
    ) as unknown as typeof Model['ZodValidator']

  constructor(payload: Partial<JobItem> = {}) {
    super(payload)
    Object.assign(this, payload)
  }
}
